import axios from "axios";

export const fetchUsers = async ({ page, search, per_page, sort }) => {
  let currentPage = page || 1;
  console.log(sort)
  let perPage = per_page || 10;
  let searchValue = search || "";
  let response;
  try {
    response = await axios({
      method: "get",
      url: `/users?page=${currentPage}&per_page=${perPage}&sort=${sort.value}&direction=${sort.direction}${
        searchValue ? `&search=${searchValue}` : ""
      }`
    });
  } catch (e) {
    console.log(e);
  }
  return response.data;
};

export const fetchUser = async id => {
  let response;
  try {
    response = await axios({
      method: "get",
      url: `/users/${id}`
    });
  } catch (e) {
    console.log(e);
  }

  return response.data;
};
export const fetchClients = async ({ page, search, per_page }) => {
  let currentPage = page || 1;
  let searchValue = search || "";
  let response;
  try {
    response = await axios({
      method: "get",
      url: `/clients?page=${currentPage}&per_page=${1000}${
        searchValue ? `&search=${searchValue}` : ""
      }`
    });
  } catch (e) {
    console.log(e);
  }

  return response.data.data;
};
export const createUser = async user => {
  let response = await axios({
    method: "post",
    url: `/users`,
    data: user
  });
  return response.data;
};

export const editUser = async (id, user) => {
  let response = await axios({
    method: "put",
    url: `/users/${id}`,
    data: user
  });
  return response.data;
};
